export const removeTokens = () => {
  localStorage.removeItem('session_id')
}
